import { render } from "./BCollapse.vue?vue&type=template&id=f6249a12"
import script from "./BCollapse.vue?vue&type=script&lang=js"
export * from "./BCollapse.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__